module.exports = __webpack_public_path__ + "static/media/browser.f8f83775.svg";